import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-home/part-home-view.tsx");
